import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Tag Multiple Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-tag-multiple-outline',
    templateUrl: './icon-tag-multiple-outline.component.html',
    styleUrls: ['./icon-tag-multiple-outline.component.scss'],
    standalone: false
})
export class IconTagMultipleOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
